import methodAPI from './methodAPI';

export const productAPI = {
    getAll: async () => {
        return await methodAPI.get('/products');
    },

    create: async (productData) => {
        return await methodAPI.post('/products', productData);
    },

    update: async (id, productData) => {
        return await methodAPI.put(`/products/${id}`, productData);
    },

    delete: async (id) => {
        return await methodAPI.delete(`/products/${id}`)
    }
};